<template>
  <div>
    <div v-if="url && isURL" class="file">
      <img style="width: 80px; height: 80px" :src="url" />
    </div>
    <div class="file-upload-wrapper">
      <input
        type="file"
        @change="handleFile"
        value="选择头像"
        style="width: 70px" />
      <span style="margin-left: 10px; color: red">{{ text }}</span>
    </div>
  </div>
</template>

<script>
// import OSS from "ali-oss";
import { upload } from "@/api/user.js";
export default {
  props: {
    text: {
      type: String,
      default: "注: 头像将用于后续视频实名认证",
    },
    isURL: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "avatar",
    },
    bizPath: {
      type: String,
      default: "profile_photo",
    },
  },
  data() {
    return {
      url: "",
    };
  },
  methods: {
    getURL(url) {
      this.url = url;
    },
    async handleFile(file) {
      console.log(file);
      let files = file.target.files[0];
      const res = await upload({ file: files, bizPath: this.bizPath });
      if (res.code == 200 && res.result) {
        this.$emit("handleUrl", res.result);
      } else {
        this.$message.error(res.message);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.file {
  position: relative;
}
</style>
